import { Box, Container, Grid } from '@mui/material'
import React from 'react'
import Navbar from './Navbar'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import Footer from './Footer'
import { useEffect } from 'react'


const Layout = () => {
  const location = useLocation()
  const navigate = useNavigate()
  useEffect(()=>{
    if(location.pathname === "/"){
      navigate('/home')
    }
  },[])
  return (
    <Container>
      <Navbar/>
      <Box component={"section"} >
        <Outlet  />
      </Box>
      <Footer/>

    </Container>
        
   
  )
}

export default Layout